import templateUrl from './system-ingredient-form.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    ingredient: '<',
    dialogTitle: '@',
    submitTitle: '@',
    ingredientChanged: '&'
  },
  controller: class SystemIngredientFormComponent {
    constructor(EventEmitter) {
      'ngInject';

      Object.assign(this, { EventEmitter });
    }

    onSubmit() {
      this.ingredientChanged(
        this.EventEmitter({
          ingredient: this.ingredient
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/system-ingredients/system-ingredient-form/system-ingredient-form.component.js